module.exports = __webpack_public_path__ + "img/Voie_Feu.66aeb427.png";